/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component } from "react";
import { Radio } from "@scuf/common";
import "../../wizard/GatewayRegistration/SiteSelection.scss";
import "./FCDIYGatewaySearchResult.scss"
import { IGatewayDetail } from "./IGatewayDetails";

const FCDIYGatewaySearchResult = (props: IGatewayDetail) => {
  let isSelected = props.selected;
  return (
    <React.Fragment>
      <div
        className={
          isSelected ? "ui-gateway-block-selected" : "ui-gateway-block-unselected"
        }
      >
        <div className="ui-site-select-radio">
          <Radio checked={isSelected} onClick={props.onSelectCall} />
        </div>
        <div className="ui-site-block-details">
          <div className="ui-site-details-name">
            {props.gatewayName}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FCDIYGatewaySearchResult;
